var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4933 9.26659C22.0933 3.10659 16.72 0.333252 12 0.333252C12 0.333252 12 0.333252 11.9867 0.333252C7.28 0.333252 1.89334 3.09325 0.493338 9.25325C-1.06666 16.1333 3.14667 21.9599 6.96001 25.6266C8.37334 26.9866 10.1867 27.6666 12 27.6666C13.8133 27.6666 15.6267 26.9866 17.0267 25.6266C20.84 21.9599 25.0533 16.1466 23.4933 9.26659ZM12 15.9466C9.68001 15.9466 7.80001 14.0666 7.80001 11.7466C7.80001 9.42659 9.68001 7.54659 12 7.54659C14.32 7.54659 16.2 9.42659 16.2 11.7466C16.2 14.0666 14.32 15.9466 12 15.9466Z",
    fill: "#F7971E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.0d8e0e2c16d87bfe0d0a82d5171777a5.svg";
export { ForwardRef as ReactComponent };